import { FacilitySnapShot } from './contexts/FacilityProvider.types';

export interface Props {}

export interface DashboardContextProps {
  state: DashboardState;
  dispatch: React.Dispatch<DashboardAction>;
  activeFacilitySnapShot: FacilitySnapShot;
  reValidateParamVersionList?: () => Promise<void>;
}
export interface ScenarioData {
  id: string;
  label: string;
}
export interface DaysData {
  id: string;
  name: string;
}
export interface ParamVersion {
  id: string;
  name: string;
}
export interface DashboardState {
  scenarios: {
    isLoading: boolean;
    data: ScenarioData[];
    selected?: string;
  };
  days: {
    isLoading: boolean;
    data: DaysData[];
    selected?: string;
  };
  paramVersions: {
    isLoading: boolean;
    data: ParamVersion[];
    selected?: ParamVersion['id'];
  };
}

type ValueOf<T> = T[keyof T];

export const DASHBOARD_ACTION_TYPES = {
  SET_SCENARIO_LIST: 'SET_SCENARIO_LIST',
  SET_SELECTED_SCENARIO: 'SET_SELECTED_SCENARIO',
  SET_SELECTED_DAY: 'SET_SELECTED_DAY',
  SET_SELECTED_PARAM_VERSION: 'SET_SELECTED_PARAM_VERSION',
  SET_PARAM_VERSIONS: 'SET_PARAM_VERSIONS',
} as const;
export interface DashboardAction {
  type: ValueOf<typeof DASHBOARD_ACTION_TYPES>;
  payload?: any;
}
